import { useEffect, useState } from 'react';

const stats = [
  { num: '500+', label: 'Signs Installed' },
  { num: '12+', label: 'Years in Austin' },
  { num: '6', label: 'Cities Covered' },
  { num: '5★', label: 'Google Rated' },
];

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { const t = setTimeout(() => setLoaded(true), 80); return () => clearTimeout(t); }, []);

  return (
    <section className="relative w-full min-h-screen flex flex-col justify-end overflow-hidden bg-[#080808]">
      {/* Cinematic BG */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/cb7b680a62271c21106a046d2a58892c.jpg"
          alt="Illuminated custom signs installed on Austin TX commercial building — Capital Area Signs"
          className="w-full h-full object-cover object-center"
        />
        {/* Layered overlays for depth */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/65 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40" />
        {/* Subtle vignette */}
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at center, transparent 30%, rgba(0,0,0,0.5) 100%)' }} />
      </div>

      {/* Floating label */}
      <div className={`absolute top-40 left-8 md:left-16 z-20 transition-all duration-700 ${loaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
        <div className="flex items-center gap-3">
          <span className="w-8 h-px bg-[#C4962A]" />
          <span className="eyebrow text-[#C4962A]">Austin, Texas — Est. Sign Authority</span>
        </div>
      </div>

      {/* Main content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 pb-0 pt-28">
        <div className="max-w-3xl">
          <div className={`transition-all duration-800 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
            style={{ transitionDelay: '0.1s' }}>
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-[0.95] tracking-tight mb-8"
              style={{ fontFamily: 'Playfair Display, serif' }}>
              Signs That<br />
              <span className="text-gradient-gold italic">Command</span><br />
              Attention.
            </h1>
          </div>

          <div className={`transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ transitionDelay: '0.25s' }}>
            <p className="text-white/65 text-lg md:text-xl leading-relaxed mb-10 max-w-xl font-light">
              Premium custom signage — designed, fabricated, and installed in Austin TX to make your business impossible to ignore.
            </p>
          </div>

          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            style={{ transitionDelay: '0.4s' }}>
            <a href="#quote" className="btn-gold text-center">
              Get a Custom Quote
              <i className="ri-arrow-right-line" />
            </a>
            <a href="tel:+15127990115" className="btn-outline-white text-center">
              <i className="ri-phone-fill" />
              Call (512) 799-0115
            </a>
          </div>
        </div>
      </div>

      {/* Stats bar — overlapping into next section */}
      <div className={`relative z-20 w-full mt-16 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
        style={{ transitionDelay: '0.55s' }}>
        <div className="bg-[#C4962A] w-full">
          <div className="max-w-7xl mx-auto px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-black/15">
              {stats.map((s, i) => (
                <div key={i} className="px-8 py-6 flex flex-col items-center text-center">
                  <span className="text-3xl md:text-4xl font-bold text-[#080808] leading-none"
                    style={{ fontFamily: 'Playfair Display, serif' }}>{s.num}</span>
                  <span className="text-[#080808]/70 text-xs font-bold uppercase tracking-widest mt-2">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
